import { getData, postData } from './http';
import { getObjectTypeAndId } from './objectType';

export function getTopEstabsForAirport(AirportCode) {
    const params = $.param({
        AirportCode
    });

    return getData(`/api2/destination/airports/getdestinationservedbyairport?${params}`, {
        cache: true,
        logErrors: false
    }).then(function(data) {
        const objectTypeAndId = getObjectTypeAndId(data);

        const request = {
            DestinationType: objectTypeAndId.Type,
            DestinationId: objectTypeAndId.Id,
            CultureCode: TRPCONFIG.Domain.CultureCode,
            DomainId: TRPCONFIG.Domain.DomainId,
            SortCriterion: 1,
            Paging: {
                Index: 0,
                Size: 3
            },
            FieldFlags: 0
        };

        return postData('/api/hotels/static/gethotelsbydestination?fields=Hotels.Id', request, { logErrors: false });
    });
}
